module.exports = __webpack_public_path__ + "ve.svg?f49a8d433ff0bab2503420518c856519";